import { render, staticRenderFns } from "./PackagingSnapshot.vue?vue&type=template&id=539ff972"
import script from "./PackagingSnapshot.vue?vue&type=script&lang=js"
export * from "./PackagingSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports